import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import {SpeakerEdit, SpeakerReadOnly} from './SpeakersForm';

export default function SpeakersPage(props: any) {
    return (
        <GenericCrudPage
            key='speaker-page'
            singularName='Speaker'
            pageTitle='Speakers'
            resource='speakers'
            allowAdd={true}
            allowEdit={true}
            allowDelete={true}
            ReadOnlyComponent={SpeakerReadOnly}
            EditFormComponent={SpeakerEdit}
            newPayload={{
                title: '',
                name: '',
                about: '',
                type: 'speaker',
            }}
            tableColumns={[
                {
                    field: 'name',
                    headerName: 'Name',
                    width: 200,
                },
                {
                    field: 'title',
                    headerName: 'Title',
                    width: 200,
                },
                {
                    field: 'featured',
                    headerName: 'Sponser',
                    width: 200,
                },
            ]}
            validateFn={(data: any) => {
                const errorsList = [];
                if (!data) return;
                if (!data.name) errorsList.push('name is required');
                if (!data.title) errorsList.push('title is required');
                if (!data.about) errorsList.push('about is required');

                return [errorsList.length == 0, errorsList];
            }}
        />
    );
}
